import app from 'flarum/forum/app';
import { tagFacts, rankLink } from './TagFacts';
import { extend } from 'flarum/common/extend';
import LinkButton from 'flarum/common/components/LinkButton';
import DataEditorPage from './DataEditorPage';
import DataHubPage from './DataHubPage';
import ResourcesPage from './ResourcesPage';
import StatePage from './StatePage';
import StatesIndexPage from './StatesIndexPage';
import { GuidePage, GuidesIndexPage } from './GuidePages';
import ElectionsPage from './ElectionsPage';
import EcowasTradePage from './EcowasTradePage';
import BusinessesPage from './BusinessesPage';
app.initializers.add('voucha-datahub', () => {
  app.routes['voucha-datahub.editor'] = {
    path: '/data-hub/editor',
    component: DataEditorPage
  };
  // The public Data Hub: full-width pages (no sidebars). "/data-hub/" works too.
  app.routes['voucha-datahub.index'] = {
    path: '/data-hub',
    component: DataHubPage
  };
  app.routes['voucha-datahub.index-slash'] = {
    path: '/data-hub/',
    component: DataHubPage
  };
  // State pages: before the dataset route, so /data-hub/states isn't read as a dataset
  app.routes['voucha-datahub.states'] = {
    path: '/data-hub/states',
    component: StatesIndexPage
  };
  app.routes['voucha-datahub.state'] = {
    path: '/data-hub/states/:slug',
    component: StatePage
  };
  // Location guides: also before the dataset route
  app.routes['voucha-datahub.guides'] = {
    path: '/data-hub/guides',
    component: GuidesIndexPage
  };
  app.routes['voucha-datahub.guide'] = {
    path: '/data-hub/guides/:slug',
    component: GuidePage
  };
  // Elections: also before the dataset route
  app.routes['voucha-datahub.elections'] = {
    path: '/data-hub/elections',
    component: ElectionsPage
  };
  app.routes['voucha-datahub.ecowas-trade'] = {
    path: '/data-hub/ecowas-trade',
    component: EcowasTradePage
  };
  // Businesses (from the business directory): also before the dataset route
  app.routes['voucha-datahub.businesses'] = {
    path: '/data-hub/businesses',
    component: BusinessesPage
  };
  app.routes['voucha-datahub.dataset'] = {
    path: '/data-hub/:key',
    component: DataHubPage
  };
  // Resources: same layout and styling as the Data Hub home
  app.routes['voucha-datahub.resources'] = {
    path: '/resources',
    component: ResourcesPage
  };

  // User menu link, only for admins and Data editors
  extend('flarum/forum/components/SessionDropdown', 'items', function (items) {
    if (!app.data.vouchaDataEditor) return;
    items.add('vouchaDataEditor', m(LinkButton, {
      icon: "fas fa-database",
      href: app.route('voucha-datahub.editor')
    }, "Data editor"), 55);
  });

  // Location tag headers: a state's ranking beside its name. The key facts themselves are in the tag's
  // About card (voucha-theme), not the header.
  extend('ext:flarum/tags/forum/components/TagHero', 'contentItems', function (items) {
    const tag = this.attrs.model;
    if (!tag || !tag.slug()) return;
    // a state's ranking sits right beside its name, as a link
    const data = tagFacts(tag.slug());
    const key = items.has('tag-title') ? 'tag-title' : null;
    if (key && data && data.rank) items.setContent(key, m("div", {
      className: "DHTagTitle"
    }, items.get(key), rankLink(data.rank)));
  });
});